export const WORKFLOW_DISPLAY_DEFAULTS = {
  SO: [
    { statusKey: 'Quote Requested', displayLabel: 'Quote Requested', tooltip: 'Initial opportunity/quote request stage.' },
    { statusKey: 'Waiting', displayLabel: 'Waiting', tooltip: 'Opportunity is active but currently waiting on a follow-up dependency.' },
    { statusKey: 'Presentation Draft', displayLabel: 'Presentation Draft', tooltip: 'Presentation is being prepared internally and has not been sent yet.' },
    { statusKey: 'Presentation Sent', displayLabel: 'Presentation Sent', tooltip: 'Presentation has been sent to the client.' },
    { statusKey: 'Estimate Draft', displayLabel: 'Estimate Draft', tooltip: 'Estimate is being prepared internally.' },
    { statusKey: 'Estimate Sent', displayLabel: 'Estimate Sent', tooltip: 'Estimate has been shared with the client.' },
    { statusKey: 'Agreement Pending', displayLabel: 'Agreement Pending', tooltip: 'Waiting for client agreement/review.' },
    { statusKey: 'Agreement Sent', displayLabel: 'Agreement Sent', tooltip: 'Agreement has been sent and is awaiting response.' },
    { statusKey: 'Client Change Requested', displayLabel: 'Client Change Requested', tooltip: 'Client asked for revisions before approval.' },
    { statusKey: 'Client Approved', displayLabel: 'Client Approved', tooltip: 'Client approved; project can move to production steps.' },
    { statusKey: 'In Production', displayLabel: 'In Production', tooltip: 'Order is actively being produced.' },
    { statusKey: 'Shipped', displayLabel: 'Shipped', tooltip: 'Order has left production and shipped.' },
    { statusKey: 'Ready to be Invoiced', displayLabel: 'Ready to be Invoiced', tooltip: 'Fulfillment complete and ready for invoicing.' },
    { statusKey: 'Invoiced', displayLabel: 'Invoiced', tooltip: 'Invoice has been issued.' },
    { statusKey: 'Paid', displayLabel: 'Paid', tooltip: 'All linked sales-order invoices (including deposits) are paid.' },
    { statusKey: 'Closed', displayLabel: 'Closed', tooltip: 'Workflow is complete and closed.' },
  ],
  PO: [
    { statusKey: 'Created', displayLabel: 'Created', tooltip: 'Purchase order has been created.' },
    { statusKey: 'Open', displayLabel: 'Open', tooltip: 'PO is active and in progress.' },
    { statusKey: 'Follow Up', displayLabel: 'Follow Up', tooltip: 'PO requires follow-up action.' },
    { statusKey: 'Submitted', displayLabel: 'Submitted', tooltip: 'Purchase order was sent to supplier/decorator.' },
    { statusKey: 'Confirmed', displayLabel: 'Confirmed', tooltip: 'Supplier/decorator confirmed the PO.' },
    { statusKey: 'Shipped', displayLabel: 'Shipped', tooltip: 'Supplier/decorator has shipped goods.' },
    { statusKey: 'Partially Received', displayLabel: 'Partially Received', tooltip: 'Some goods have been received; more pending.' },
    { statusKey: 'Received', displayLabel: 'Received', tooltip: 'Goods have been fully received.' },
    { statusKey: 'Production Scheduled', displayLabel: 'Production Scheduled', tooltip: 'At least one linked decorator production step is scheduled; production has not started.' },
    { statusKey: 'In Progress', displayLabel: 'In Progress', tooltip: 'PO remains operationally in progress.' },
    { statusKey: 'Production Complete', displayLabel: 'Production Complete', tooltip: 'Supplier/decorator production is complete but has not necessarily shipped.' },
    { statusKey: 'Ready For Billing', displayLabel: 'Ready For Billing', tooltip: 'PO is ready for billing workflow.' },
    { statusKey: 'Billed', displayLabel: 'Billed', tooltip: 'PO has been billed.' },
    { statusKey: 'Closed', displayLabel: 'Closed', tooltip: 'PO workflow is complete and closed.' },
  ],
  GLOBAL: [
    { statusKey: 'Open', displayLabel: 'Open', tooltip: 'Project is active.' },
    { statusKey: 'Closed', displayLabel: 'Closed', tooltip: 'Project is closed.' },
  ],
};

export const buildWorkflowDisplayDraft = (source = {}) => {
  const raw = source && typeof source === 'object' ? source : {};
  const out = { SO: {}, PO: {}, GLOBAL: {} };

  Object.entries(WORKFLOW_DISPLAY_DEFAULTS).forEach(([group, rows]) => {
    const groupRaw = raw[group] && typeof raw[group] === 'object' ? raw[group] : {};
    rows.forEach((row) => {
      const itemRaw = groupRaw[row.statusKey] && typeof groupRaw[row.statusKey] === 'object'
        ? groupRaw[row.statusKey]
        : {};
      out[group][row.statusKey] = {
        displayLabel: String(itemRaw.displayLabel || '').trim() || row.displayLabel,
        tooltip: String(itemRaw.tooltip || '').trim() || row.tooltip,
      };
    });
  });

  return out;
};
